import { render, staticRenderFns } from "./CompetitorsPricesList.vue?vue&type=template&id=4ceef6c9&scoped=true"
import script from "./CompetitorsPricesList.vue?vue&type=script&lang=ts"
export * from "./CompetitorsPricesList.vue?vue&type=script&lang=ts"
import style0 from "./CompetitorsPricesList.vue?vue&type=style&index=0&id=4ceef6c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceef6c9",
  null
  
)

export default component.exports